<template>
  <div>
    <AvsTabs v-model="selectedTab">
      <template #tabs>
        <v-tab>
          <v-icon left> mdi-badge-account-horizontal-outline </v-icon>
          {{ $t("commons.informations") }}
        </v-tab>
        <v-tab>
          <v-icon left> mdi-lock-reset </v-icon>
          {{ $t("commons.pwd") }}
        </v-tab>
      </template>

      <template #items>
        <v-tab-item>
          <div class="subtitle-1 text--disabled">
            {{ $t("views.personal_settings.subtitle") }}
          </div>

          <div class="d-flex flex-wrap row-gap-5 mt-5">
            <div class="col-12 col-md-6">
              <v-form
                ref="profile-form"
                v-model="isFormValid['profile-form']"
              >
                <v-text-field
                  clearable
                  :label="$t('commons.first_name')"
                  :rules="rules.profile.first_name"
                  v-model="profile.first_name"
                ></v-text-field>

                <v-text-field
                  clearable
                  :label="$t('commons.last_name')"
                  :rules="rules.profile.last_name"
                  v-model="profile.last_name"
                ></v-text-field>
                <v-text-field
                  :rules="rules.profile.email"
                  :label="$t('commons.email')"
                  disabled
                  v-model="profile.email"
                ></v-text-field>

                <div class="d-flex flex-column align-end">
                  <avs-saveButton
                    :disabled="!isFormValid['profile-form'] || hasChangedProfile"
                    :loading="changedForm"
                    @click="save('profile-form')"
                  />
                </div>
              </v-form>
            </div>

            <div class="col-12 col-md-6">
              <v-data-table
                :headers="headers"
                :items="itemsCompanies"
                hide-default-footer
                class="elevation-0"
              >
                <template v-slot:item.company_role="{ item }">
                  <avs-role :role="item.company_role" />
                </template>
                <template v-slot:item.actions="{ item }">
                  <avs-leaveButton
                    :disabled="isAdmin(item.company_role)"
                    @click.stop="handleOpenDeleteDialog(item)"
                    :spantext="
                      $t('actions.leave', { entity: $t('categories.company.name').toLowerCase() })
                    "
                  />
                </template>
              </v-data-table>
            </div>
          </div>
        </v-tab-item>

        <v-tab-item>
          <div class="subtitle-1 text--disabled">
            {{ $t("views.personal_settings.changing_pwd_subtitle") }}
          </div>
          <div class="d-flex mt-10">
            <div class="col-12 col-md-6">
              <v-form
                ref="change-password-form"
                v-model="isFormValid['change-password-form']"
              >
                <v-text-field
                  clearable
                  :label="$t('views.personal_settings.current_pwd')"
                  :rules="rules.password.old"
                  v-model="password.old"
                  :type="showPassword.old ? 'text' : 'password'"
                  autocomplete="off"
                  :append-icon="showPassword.old ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword.old = !showPassword.old"
                ></v-text-field>

                <v-text-field
                  clearable
                  :label="$t('views.personal_settings.new_pwd')"
                  :rules="rules.password.new"
                  v-model="password.new"
                  :type="showPassword.new ? 'text' : 'password'"
                  autocomplete="off"
                  :append-icon="showPassword.new ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword.new = !showPassword.new"
                ></v-text-field>

                <v-text-field
                  clearable
                  :label="$t('views.personal_settings.repeat_pwd')"
                  :rules="rules.password.newRepeat"
                  v-model="password.newRepeat"
                  :type="showPassword.newRepeat ? 'text' : 'password'"
                  autocomplete="off"
                  :append-icon="showPassword.newRepeat ? 'mdi-eye-off' : 'mdi-eye'"
                  @click:append="showPassword.newRepeat = !showPassword.newRepeat"
                ></v-text-field>
                <div class="d-flex flex-column align-end">
                  <avs-saveButton
                    :disabled="!isFormValid['change-password-form']"
                    :loading="changedForm"
                    @click="save('change-password-form')"
                  />
                </div>
              </v-form>
            </div>
          </div>
        </v-tab-item>
      </template>
    </AvsTabs>
    <avs-deleteDialog
      v-model="deleteDialogIsOpen"
      @cancel="handleCancel"
      @delete="leaveCompany"
      :resource="$t('categories.company.name').toLowerCase()"
    />
  </div>
</template>

<script>
import { AccountService } from "@/services"
import { initials } from "@/utils/string"
import { required, email, password } from "@/utils/validator"
import CompanyService from "@/services/CompanyService"
import { isAdmin } from "@/utils/middleware"

export default {
  components: {
    AvsTabs: () => import("@/components/generics/general/AvsTabs.vue")
  },
  data() {
    return {
      deleteDialogIsOpen: false,
      selectedTab: null,
      showPassword: {
        old: false,
        new: false,
        newRepeat: false
      },
      profile: {
        email: "mark.trenton@ri3.com",
        first_name: "Mark",
        last_name: "Trenton"
      },
      password: {
        old: "",
        new: "",
        newRepeat: ""
      },
      isFormValid: {
        "change-password-form": true,
        "profile-form": true
      },
      rules: {
        profile: {
          first_name: [required],
          last_name: [required],
          email: [required, email]
        },
        password: {
          old: [required],
          new: [required, password],
          newRepeat: [
            required,
            password,
            v =>
              v === this.password.new || this.$t("views.personal_settings.verify_right_entered_pwd")
          ]
        }
      },
      changedForm: false,
      refProfile: {
        first_name: "",
        last_name: ""
      },
      headers: [
        {
          text: this.$t("categories.company.name"),
          align: "start",
          sortable: "true",
          value: "name"
        },
        { text: this.$t("commons.role"), align: "center", sortable: "true", value: "company_role" },
        { text: this.$t("commons.actions"), sortable: false, value: "actions", align: "right" }
      ],
      itemsCompanies: [],
      selectedItem: null
    }
  },
  computed: {
    hasChangedProfile() {
      return (
        this.profile.first_name == this.refProfile?.first_name &&
        this.profile.last_name == this.refProfile?.last_name
      )
    }
  },
  mounted() {
    this.getCompanyInfos()
  },
  created() {
    this.patchValues(this.$store.state.app.user)
  },
  methods: {
    initials,
    isAdmin,
    leaveCompany() {
      CompanyService.selfRemoveFromCompany(this, this.selectedItem.pk).then(r => {
        this.$store.commit("app/message", {
          msg: "User removed from the company",
          color: "success"
        })
        this.getCompanyInfos()
      })
      this.deleteDialogIsOpen = false
    },
    handleOpenDeleteDialog(item) {
      this.deleteDialogIsOpen = true
      this.selectedItem = item
    },
    handleCancel() {
      this.deleteDialogIsOpen = false
    },
    patchValues(v) {
      this.profile.email = v.email
      this.profile.first_name = v.first_name
      this.profile.last_name = v.last_name
      this.refProfile.first_name = v.first_name
      this.refProfile.last_name = v.last_name
    },
    resetValidation(formRef) {
      if (formRef && this.$refs[formRef]) this.$refs[formRef].resetValidation()
    },
    reset(formRef) {
      if (formRef && this.$refs[formRef]) {
        this.$refs[formRef].reset()
        this.resetValidation(formRef)
      }
    },
    save(formRef) {
      if (this.changedForm) return
      this.$refs[formRef].validate()
      this.$nextTick(() => {
        if (this.isFormValid[formRef]) {
          switch (formRef) {
            case "change-password-form":
              this.submitChangePassword()
              break
            case "profile-form":
              this.submitProfile()
              break
          }
        }
      })
    },
    submitChangePassword() {
      const formRef = "change-password-form"
      AccountService.changePassword(
        this,
        this.password.old,
        this.password.new,
        this.password.newRepeat
      )
        .then(() => {
          this.reset(formRef)
        })
        .finally(() => {
          this.changedForm = false
        })
    },
    submitProfile() {
      const $ = this
      AccountService.updateProfileInfo(
        $,
        $.profile.first_name,
        $.profile.last_name,
        $.profile.email
      )
        .then(() => {
          $.$nextTick(() => {
            $.patchValues($.$store.state.app.user)
          })
        })
        .finally(() => {
          $.changedForm = false
        })
    },
    getCompanyInfos() {
      const $ = this
      CompanyService.getAll()
        .then(results => {
          this.itemsCompanies = results
        })
        .finally(() => {
          $.changedForm = false
        })
    }
  }
}
</script>

<style>
.row-gap-5 {
  row-gap: 20px;
}
</style>
